import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET All Tables by Date for CFRM ******************//
export const exportCFRM = async (a) => {
    try{
     // const a = { orgID: sessionStorage.getItem('org'), projID: sessionStorage.getItem('project')}
    const resrep = await axios.post(
      `${api}/exportCFRM`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`exportCFRM controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`exportCFRM controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}